<template>
  <div>
    <el-dialog
      :visible="showPreview"
      @close="$emit('update:showPreview', false)"
    >
      <div class="container" v-if="showPreview && fileList[idx]">
        <!-- <div class="container-arrow left" @click.stop="changeFile(-1)">
          <i class="el-icon-arrow-left"></i>
        </div> -->
        <el-button
          class="container-arrow left"
          round
          @click.stop="changeFile(-1)"
        >
          <i class="el-icon-arrow-left"></i>
        </el-button>
        <img
          style="object-fit:scale-down"
          v-if="fileList[idx].file_type === 1"
          :src="fileList[idx].file_url"
          alt=""
        />
        <video
          width="100%" style="height: inherit;"
          autoplay
          controls
          v-else-if="fileList[idx].file_type === 2"
          :src="fileList[idx].file_url"
        ></video>
        <template v-else-if="fileList[idx].file_type === 3">
            <img class="audio-img" src="../../common/images/audio-default.svg" style="width:200px;height:200px;animation: circle 2s linear infinite;">
            <audio autoplay="" loop="" style="display: none;" :src="fileList[idx].file_url"></audio>
        </template>
        <!-- <div class="container-arrow right" @click.stop="changeFile(1)">
          <i class="el-icon-arrow-right"></i>
        </div> -->
        <el-button
          class="container-arrow right"
          round
          @click.stop="changeFile(1)"
        >
          <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    showPreview: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    idx: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    changeFile(num) {
      let msg = this.idx + num < 0 ? '当前已经是当前页第一个文件了' : this.idx + num > this.fileList.length -1 ? '这已经是当前页最后一个文件了' : false
      if (msg) {
        this.$message.info(msg)
        return;
      } else {
        this.$emit("update:idx", this.idx + num);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  ::v-deep .el-button:active{
    border-color:#FFF;
  }
  img {
    height: 100%;
  }
  .container-arrow {
    padding: 0;
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    line-height: 30px;
    text-align: center;
    transition: all 0.1s;
    z-index:99999;
    font-size:28px;
  }
  .container-arrow:hover {
    transform: translateY(-50%) scale(1.1);
  }
  .container-arrow:active{
    background: rgba(0, 0, 0, 0.6);
    transform: translateY(-50%) scale(1);
  }
  .right {
    right: -10px;
  }
  .left {
    left: -10px;
  }
}
</style>